import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  CanLoad,
  Router,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class NavigatorsCheckGuard implements CanActivate, CanActivateChild, CanLoad {
  /**
   * @description constructor
   * @params router
   */
  constructor(private router: Router) {
    this.router = router;
  }
  /**
   * @description can activate
   */
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkDevice();
  }
  /**
   * @description can activate child
   */
  canActivateChild(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkDevice();
  }
  /**
   * @description can load
   */
  canLoad(): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkDevice();
  }
  /**
   *   @description is IE
   */
  isIE(): boolean {
    let isIE = false;
    const fakeNavigatorObj: Navigator = window.navigator;
    const ua: string = fakeNavigatorObj.userAgent;
    const oldie: number = ua.indexOf('MSIE ');
    if (oldie > -1) {
      isIE = true;
    }
    return isIE;
  }
  /**
   * @description check device
   */
  checkDevice(): boolean | Promise<boolean> {
    let result = true;
    if (this.isIE()) {
      this.router.navigate(['browser-no-compatible']);
      result = false;
    }
    return result;
  }
}
